export enum AvatarMenuTab {
    Practice = 'practice',
    Payment = 'payment',
    RewardStatus = 'rewardStatus',
    Password = 'password',
    Credit = 'credit',
}
